import { render, staticRenderFns } from "./master-class.html?vue&type=template&id=7b74742c&scoped=true&"
import script from "./master-class.js?vue&type=script&lang=js&"
export * from "./master-class.js?vue&type=script&lang=js&"
import style0 from "./master-class.css?vue&type=style&index=0&id=7b74742c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b74742c",
  null
  
)

export default component.exports